import { Component, inject, OnInit } from '@angular/core';
import { ChatService } from '../services/chat-service/chat.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { RecentChatSearch } from './recent-chat-search/recent-chat-search';

@Component({
  templateUrl: './recent-chats-section.html',
  styleUrl: './recent-chats-section.scss',
  selector: 'recent-chats-section',
  imports: [RouterLink, RouterLinkActive, RecentChatSearch],
})
export class RecentChatsSection implements OnInit {
  private chatService = inject(ChatService);
  readonly chatsList = this.chatService.listChats;

  ngOnInit(): void {
    this.loadData();
  }
  loadData = (): void => {
    this.chatService.listChatWithParams({
      limit: 3,
    });
  };
}
